<label mat-dialog-title class="add-title">{{ titles.title }}</label>
<mat-dialog-content>
  <form
    class="d-flex justify-content-between flex-wrap align-items-start"
    [formGroup]="myValidate"
  >
 <!--    <mat-expansion-panel
      
      [expanded]="true"
      [disabled]="!isMobile"
      class="col-12 col-md-4 col-lg-4 add-detail"
    >
      <mat-expansion-panel-header>
        <mat-panel-title class="uk-text-subheading">
          Configuración
        </mat-panel-title>
      </mat-expansion-panel-header> -->
      <div class="col-12 col-md-4 col-lg-4 add-detail"
      >
        <div
          *ngIf="customerInformation.addresses.length !== 0 && !isEditDispatch"
          class="row isHistorial"
        >
          <mat-form-field class="col-9">
            <mat-label>Direcciones anteriores</mat-label>
            <mat-select
              id="addressList"
              required
              formControlName="fullAddress"
              disableOptionCentering="true"
            >
              <mat-option value="new">Ingresando nueva dirección</mat-option>
              <mat-option
                *ngFor="let item of historyAddress"
                [value]="item.ubigeoCode + item.address + item.number"
                [disabled]="!item.active"
              >
                {{ item.address | uppercase }}
                NRO. {{ item.number | uppercase }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <button
            type="button"
            id="addNewAddress"
            class="button-success col-3"
            mat-flat-button
            matTooltip="Agregar dirección"
            (click)="newAddress()"
          >
            <mat-icon>add</mat-icon>
          </button>
        </div>
        <ng-container *ngIf="(myValidate.controls['fullAddress'].value === 'new' || editDistrict); else txtHide">            
          <app-locations
            [isModuleNV]="true"
            [isHistorial]="
              myValidate.controls['stateAddress'].value && !isEditDispatch
            "
            [isColumn]="true"
            [isEditDispatch]="isEditDispatch"
            [isDepartment]="true"
            [isProvince]="true"
            [isDistrict]="true"
            [localStore]="false"
            [data]="componentLocations"
            (idDepartment)="_addZoneOfDepartment($event)"
            (idProvince)="_addZoneOfProvince($event)"
            (idDistrict)="_addAllPlaces($event)"
          ></app-locations>
        </ng-container>
        <ng-template #txtHide>
          <div class="row">
            <mat-form-field class="text-underline-hide col-6 col-md-12">
              <mat-label>Departamento/Provincia</mat-label>
              <input matInput formControlName="department" readonly>
            </mat-form-field>
            <mat-form-field class="text-underline-hide col-6 col-md-12">
              <mat-label>Provincia/Cantones</mat-label>
              <input matInput formControlName="province" readonly>
            </mat-form-field>
            <mat-form-field class="col-12" [ngClass]="{'text-underline-hide  mb-2': !isEditDispatch}">
              <mat-label>Distrito/Parroquias</mat-label>
              <input matInput formControlName="district" [readonly]="!isEditDispatch">
              <mat-icon matSuffix (click)="editDisrict()" *ngIf="isEditDispatch">edit</mat-icon>
            </mat-form-field>
          </div>
        </ng-template>
        <div class="row">
          <mat-form-field class="col-md-5">
            <mat-label>Tipo de Vivienda *</mat-label>
            <mat-select
              id="addressType"
              formControlName="addressType"
              disableOptionCentering="true"
            >
              <mat-option *ngFor="let item of addressType" [value]="item.value">
                {{ item.viewValue }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="col-md-7">
            <mat-label>Dirección sin número *</mat-label>
            <input
              matInput
              type="text"
              id="addressAddress"
              formControlName="address"
              autocomplete="off"
              (blur)="removeSpaces('address')"
            />
            <mat-error *ngFor="let validation of validation_messages.address">
              <span
                class="mat-error"
                *ngIf="
                  myValidate.get('address').hasError(validation.type) &&
                  (myValidate.get('address').dirty ||
                    myValidate.get('address').touched)
                "
              >
                {{ validation.message }}
              </span>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="row">
          <mat-form-field class="col-4 col-md-5 col-lg-5">
            <mat-label>Nro./Mz./Bloq.*</mat-label>
            <input
              matInput
              type="text"
              id="addressNumber"
              class="input-sm"
              formControlName="number"
              autocomplete="off"
              (blur)="removeSpaces('number')"
            />
            <mat-error *ngFor="let validation of validation_messages.number">
              <span
                class="mat-error"
                *ngIf="
                  myValidate.get('number').hasError(validation.type) &&
                  (myValidate.get('number').dirty ||
                    myValidate.get('number').touched)
                "
              >
                {{ validation.message }}
              </span>
            </mat-error>
          </mat-form-field>
          <mat-form-field class="col-4 col-lg-4 col-md-4">
            <mat-label>Dep./Int./Lt.</mat-label>
            <input
              matInput
              type="text"
              id="departmentNumber"
              class="input-sm"
              formControlName="departmentNumber"
              autocomplete="off"
              (blur)="removeSpaces('departmentNumber')"
            />
            <mat-error
              *ngFor="let validation of validation_messages.departmentNumber"
            >
              <span
                class="mat-error"
                *ngIf="
                  myValidate
                    .get('departmentNumber')
                    .hasError(validation.type) &&
                  (myValidate.get('departmentNumber').dirty ||
                    myValidate.get('departmentNumber').touched)
                "
              >
                {{ validation.message }}
              </span>
            </mat-error>
          </mat-form-field>
          <mat-form-field class="col-4 col-lg-3 col-md-3">
            <mat-label>Piso *</mat-label>
            <input
              matInput
              type="text"
              id="addressFloor"
              name="number"
              class="input-sm"
              [matTooltip]="floorEntityMessage"
              (keypress)="validateInput($event)"
              formControlName="floor"
              autocomplete="off"
              (blur)="removeSpaces('floor')"
            />
            <mat-error *ngFor="let validation of validation_messages.floor">
              <span
                class="mat-error"
                *ngIf="
                  myValidate.get('floor').hasError(validation.type) &&
                  (myValidate.get('floor').dirty ||
                    myValidate.get('floor').touched)
                "
              >
                {{ validation.message }}
              </span>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="row">
          <mat-form-field class="col-md-12">
            <mat-label>Escriba algún dato adicional</mat-label>
            <input
              matInput
              type="text"
              id="addressReference"
              formControlName="reference"
              autocomplete="off"
              (blur)="removeSpaces('reference')"
            />
          </mat-form-field>
        </div>
      </div>
    <!-- </mat-expansion-panel> -->
    <div class="col-12 col-md-8 col-lg-8 map-container">
      <div class="map-content">
        <app-maps
          [isDraggable]="true"
          [point]="pointGeolocation"
          [address]="aliasGeolocation"
          (locationMarker)="locationMarker($event)"
        >
        </app-maps>
      </div>
      <button
        mat-flat-button
        class="button-success"
        id="updateAddressMap"
        [disabled]="activeGeo"
        (click)="validateGeolocation()"
      >
        Ubicar con geolocalización
      </button>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end" class="card-button">
  <span *ngIf="!myValidate.controls['active'].value" class="inactivo">Dirección inhabilitada</span>
  <button
    mat-stroked-button
    class="border-box b-s"
    mat-dialog-close
    id="cancelAddAddress"
    (click)="onNoClick()"
  >
    Cancelar
  </button>
  <button
    mat-flat-button
    id="submitAddAddress"
    [mat-dialog-close]="address"
    cdkFocusInitial
    class="button-primary-event button-success"
    [disabled]="!myValidate.valid || !myValidate.controls['active'].value"
  >
    {{ titles.titleButton }}
  </button>
</mat-dialog-actions>
<button id="closeAddAddress" mat-button mat-dialog-close class="dialog-close">
  <mat-icon>close</mat-icon>
</button>
